<div style="padding:20px"> 
    <ul class="nav nav-tabs" style="margin: 10px;">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item" (click)="choose(item.id)">
            <a onclick="return false;" [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</a>
        </li>
    </ul>
    <hr>
    <button (click)="add()" class="btn btn-primary">點我新增題目</button>
    
    <app-table-v2  *ngIf="data.length>0" [type]="1" [tcontent]="tcontent" [data]="data">
        <ng-template let-post #operation_dk>
            <div *ngIf="post.key == 'gg'">
                <td><button (click)="edit_data=post.val;now='0'"  class="btn btn-danger" data-toggle="modal" data-target=".bd-example-modal-lg">點我編輯</button></td> 
            </div>
            <div *ngIf="post.key == 'gg1'">
                <td><button (click)="edit_data=post.val;now='1'"  class="btn btn-danger" data-toggle="modal" data-target=".bd-example-modal-lg">點我編輯</button></td>             
            </div>
        </ng-template> 
    </app-table-v2>

    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    <div *ngIf="data.length==0">無資料</div>
</div>

<div 
*ngIf="edit_data"
class="modal fade bd-example-modal-lg" tabindex="-1"
 role="dialog"  data-keyboard="false" data-backdrop="static" 
 aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"

 >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">


      <div class="modal-body"> 
        <div class="wrape_item"  *ngIf="now=='0'">
           <span class="show_title" >問題:</span><input type="text" 
            [(ngModel)]="edit_data.question" 
            class="form-control show_input" 
          >
        </div>
        <div class="wrape_item"  *ngIf="now=='0'">
           <span class="show_title" >提示:</span><input type="text" 
            [(ngModel)]="edit_data.hint" 
            class="form-control show_input" 
          >
        </div>
        <div class="wrape_item"  *ngIf="now=='1'">
           <span class="show_title" >問題:</span><input type="text" 
            [(ngModel)]="edit_data.description" 
            class="form-control show_input" 
          >
        </div>

        <div class="wrape_item" *ngIf="now=='1'||now=='0'">
          <span class="show_title">加成係數:</span><input type="range" 
          class="form-range" min="0" max="20" step="1" 
          [(ngModel)]="edit_data.ratio" id="customRange1">
          {{edit_data.ratio}}
      </div>


        <div class="wrape_item" *ngIf="now=='1'">
            <span class="show_title">私密等級:</span><input type="range" 
            class="form-range" min="0" max="3" step="1" 
            [(ngModel)]="edit_data.lv" id="customRange1">
            {{edit_data.lv}}
        </div>

        <div class="wrape_item" style="margin:20px 0px 0px 0px" *ngIf="now=='1'">
          <span class="show_title" >類型:</span>
          <input type="radio" name="type"  [(ngModel)]="edit_data.type" value="1">真心話
          <input type="radio" name="type" [(ngModel)]="edit_data.type" value="2">大冒險

       </div>

         <div class="wrape_item" style="margin:20px 0px 0px 0px" *ngIf="now=='1'||now=='0'">
            <span class="show_title" >狀態:</span>
            <input type="radio" name="status" [(ngModel)]="edit_data.is_enable" value="1">上架
            <input type="radio" name="status" [(ngModel)]="edit_data.is_enable" value="0">下架
            <input type="radio" name="status" [(ngModel)]="edit_data.is_enable" value="-1">刪除
         </div>
      </div>

      <div class="modal-footer">
          <button type="button"  (click)="save(0)"  class="btn btn-primary" data-dismiss="modal">確認</button>
          <button type="button"  (click)="init_list()" class="btn btn-danger" data-dismiss="modal">取消</button>
      </div>
      </div>
  </div>
</div>
<app-spinner [loading]="loading"></app-spinner>